import React from 'react';
import { Link } from 'react-router-dom';
import { trackNow } from 'shared/models/analytic';
import { trackInfo } from 'shared/models/product';
import { H5, SmallAlt } from 'scy/text';
import { PrimaryButton } from 'scy/buttons';
import { ProductImage } from 'scy/ProductImage';
import PriceDisplay from 'components/product/priceDisplay';
import { maxWidth100 } from 'scy/utils.mod.scss';
import { inlineBlock } from 'scy/display.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function Product({ product, add }) {
  const { title, subtitle, volume, price, description } = product;

  let url = product.url || '';
  if (url[0] !== '/') url = '/' + url;

  function track() {
    return trackNow('Product Clicked', trackInfo(product));
  }

  function handleClick(e) {
    e.stopPropagation();
    return add();
  }

  return (
    <article className={styles.product}>
      <div className={styles.imageContainer}>
        <Link to={url} onClick={track}>
          <ProductImage
            product={product}
            alt={title}
            className={`${maxWidth100} ${margin.bottom_sm}`}
          />
        </Link>
        {!!price && (
          <PrimaryButton className={styles.addButton} onClick={handleClick}>
            Add
          </PrimaryButton>
        )}
      </div>

      <Link
        to={url}
        onClick={track}
        className={`${inlineBlock} ${margin.bottom_xs}`}
      >
        <H5 uppercase tag="h1">
          {title}
        </H5>
        <H5 uppercase tag="h2">
          {subtitle}
        </H5>
        <H5 uppercase tag="h3">
          <span>{volume}</span>
          {!!price && <PriceDisplay product={product} />}
        </H5>
      </Link>

      <SmallAlt tag="p" marginClass={`${margin.top_0} ${margin.bottom_md}`}>
        {description}
      </SmallAlt>
    </article>
  );
}
